import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { updatePost } from '../../../util/api';
import { IconSpinner, NamedLink } from '../../../components';
import css from './BlogFeed.module.css';

const BlogFeed = (props) => {
    const {
        loading,
        posts,
        setPosts,
        isAdmin,
        onEditPost,
    } = props;

    const showPosts = isAdmin
        ? posts
        : posts.filter(p => !p.closed);

    const noPosts = showPosts.length == 0;

    const onTogglePost = post => {
        const { _id, closed } = post;
        updatePost({
            _id,
            closed: !closed,
        })
            .then(() => {
                const allOtherPosts = posts.filter(p => p._id !== _id);
                const updatedPost = posts.find(p => p._id == _id);
                setPosts([
                    {
                        ...updatedPost,
                        closed: !closed,
                    },
                    ...allOtherPosts,
                ]);
            })
            .catch(() => {
                alert("Failed to close post.")
            });
    };

    if (loading) {
        return <IconSpinner />
    } else if (noPosts) {
        return <FormattedMessage id="BP.feed.empty" />
    };

    return <div className={css.root}>
        {showPosts.map(post => {
            const {
                date,
                link,
                pictureURL,
                title,
                closed,
                _id,
            } = post;

            return <NamedLink
                key={_id}
                className={css.post}
                name="BlogPost"
                params={{ postUniqueLink: link }}
            >
                {isAdmin ? <div className={css.actions}>
                    <div onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onEditPost(post._id);
                    }}>
                        Edit post
                    </div>
                    <div onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onTogglePost(post);
                    }}>
                        {closed ? "Open post" : "Close post"}
                    </div>
                </div> : null}

                <div className={css.tile}>
                    <img className={css.image} src={pictureURL} alt={title} />
                </div>

                <div className={css.caption}>
                    <div className={css.title}>
                        {title}
                    </div>
                    <div className={css.date}>
                        {new Date(date).toLocaleDateString("en-GB")}
                    </div>
                </div>
            </NamedLink>
        })}
    </div>
};

export default BlogFeed;
